import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles,
} from '@material-ui/core';
import { useState } from 'react';

import { useCreateSegmentInvoice } from '../../hooks/create-segment-invoice.hook';
import {
  getDefaultInvoiceGenerationSettings, hasInvalidInterval, InvoiceGenerationSettingsFields,
} from '../Forms/InvoiceGenerationSettingsFields.component';

type Props = {
  open: boolean;
  segmentId: string;
  onClose: () => void;
  onCreated: () => void;
};

const useStyles = makeStyles((theme) => ({
  submitButton: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export function CreateSegmentInvoiceModal({ open, segmentId, onClose, onCreated }: Props) {
  const classes = useStyles();
  const [settings, setSettings] = useState(getDefaultInvoiceGenerationSettings());

  const { createInvoice, isLoading } = useCreateSegmentInvoice();

  const handleSubmit = async () => {
    const result = await createInvoice({ segmentId, ...settings });
    if (result) {
      onCreated();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Nouvelle facture</DialogTitle>
      <DialogContent>
        <InvoiceGenerationSettingsFields value={settings} onChange={setSettings} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Annuler</Button>
        <Button
          className={classes.submitButton}
          onClick={handleSubmit}
          variant="contained"
          disabled={isLoading || hasInvalidInterval(settings) || !settings.from || !settings.to}
        >
          {isLoading ? 'Génération…' : 'Générer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
